module.exports = __webpack_public_path__ + "static/media/techimage2.d7950062.jpg";